import { gql } from '@apollo/client';

export const UPDATE_FIND_GROUP_MUTATION = gql`
  mutation UpdateFindGroupMutation($id: String!, $group: FindGroupInput!) {
    updateFindGroup(id: $id, group: $group) {
      ... on UpdateFindGroupSuccess {
        group {
          id
          createdAt
          createdBy
          name
          description
          shared
          level
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
